__turbopack_context__.v({
  "description": "SessionExpiredModal-module__8CStkG__description",
  "logoutBtn": "SessionExpiredModal-module__8CStkG__logoutBtn",
  "modal": "SessionExpiredModal-module__8CStkG__modal",
  "overlay": "SessionExpiredModal-module__8CStkG__overlay",
  "root": "SessionExpiredModal-module__8CStkG__root",
  "title": "SessionExpiredModal-module__8CStkG__title",
});
